import { Block, List, ListItem, Page, Popup } from "framework7-react";
import { useState } from "react";
import { useSelector } from "react-redux";
import PopupNavbar from "../../components/popup-navbar";
import { usePopupBackClose } from "../../hooks/use-back-close";
import {
  selectCurrentGroupId,
  selectGroupTags,
} from "../../redux/reducer/app-slice";
import { countLabel } from "../../utils/format";
import { isPendingTagId, PENDING_TEXT } from "../../utils/outbox";
import { sortTagsByName } from "../../utils/tag-suggestions";
import TagEditPopup from "./tag-edit-popup";

const TagsPopup = ({ opened, onClose }) => {
  const [editing, setEditing] = useState({ opened: false, tag: null });
  const tags = useSelector(selectGroupTags);
  const groupId = useSelector(selectCurrentGroupId);
  const backClose = usePopupBackClose(opened);

  return (
    <Popup
      {...backClose}
      className="tags-popup"
      opened={opened}
      onPopupClosed={() => {
        setEditing((current) => ({ ...current, opened: false }));
        onClose();
      }}
    >
      <Page>
        <PopupNavbar title="Tags verwalten" />
        <div className="tags-content">
          {tags.length === 0 ? (
            <Block key="empty" className="tags-empty">
              Noch keine Tags. Du vergibst sie beim Erfassen einer Ausgabe.
            </Block>
          ) : (
            <List key="list" strong inset dividers className="tags-list">
              {sortTagsByName(tags).map((tag) => {
                const pending = isPendingTagId(tag.id);
                return (
                  <ListItem
                    key={tag.id}
                    className="tags-list-item"
                    link={!pending}
                    title={tag.name}
                    footer={pending ? PENDING_TEXT : undefined}
                    after={countLabel(tag.usage ?? 0, "Ausgabe", "Ausgaben")}
                    onClick={() => {
                      if (!pending) setEditing({ opened: true, tag });
                    }}
                  >
                    <span
                      slot="media"
                      className="tag-color-dot"
                      style={
                        tag.color ? { "--tag-color": tag.color } : undefined
                      }
                    />
                  </ListItem>
                );
              })}
            </List>
          )}
        </div>

        {/* Popup rule: one always-rendered wrapper per nested popup – see AGENTS.md. */}
        <div className="tag-edit-popup-wrapper">
          <TagEditPopup
            groupId={groupId}
            tag={editing.tag}
            opened={editing.opened}
            onClose={() =>
              setEditing((current) => ({ ...current, opened: false }))
            }
          />
        </div>
      </Page>
    </Popup>
  );
};

export default TagsPopup;
